import type { ReactNode } from 'react';
import './contained-page.css';

interface ContainedPageProps {
  /** Optional toolbar rendered inside a full-width bar with a centered 1200px inner. */
  toolbar?: ReactNode;
  /** When true, the body is also constrained to 1200px and given comfortable padding. */
  contained?: boolean;
  /**
   * When true, both toolbar inner + body stretch to the full viewport width
   * (with the same comfortable gutter). Use for dense, wide data tables where
   * the 1200px cap wastes screen real estate. Takes precedence over
   * `contained`.
   */
  wide?: boolean;
  children: ReactNode;
}

/**
 * Full-frame page primitive used across internal-v2 admin/contained pages:
 * full-width toolbar/body with a 1200px max-width centered inner column. Pair
 * with page-specific CSS for the toolbar contents.
 */
export function ContainedPage({
  toolbar,
  contained,
  wide,
  children,
}: ContainedPageProps) {
  const toolbarInnerCls = wide ? 'cp-toolbar-inner wide' : 'cp-toolbar-inner';
  const bodyCls = wide
    ? 'cp-body ds-scroll wide'
    : `cp-body ds-scroll${contained ? ' contained' : ''}`;
  return (
    <div className="cp-frame">
      {toolbar && (
        <div className="cp-toolbar">
          <div className={toolbarInnerCls}>{toolbar}</div>
        </div>
      )}
      <div className={bodyCls}>{children}</div>
    </div>
  );
}
